import React from 'react'

import { ConfirmationModal, ModalActionTypes, Spinner } from '@acorns/web-components'
import { compose, lifecycle } from 'recompose'
import styled from 'styled-components'

import CheckImage from 'assets/icons/check-gray-bg.svg'
import { TestIDs } from 'test/utils/testIds'
import trackEvent from 'utils/analytics/trackEvent'

import { buttonTapped, modalViewed } from './events'
import { WithResumeFlowProps } from './withResumeFlow'

const ResumeFlow = compose<WithResumeFlowProps, WithResumeFlowProps>(
  lifecycle<WithResumeFlowProps, {}>({
    componentDidMount() {
      const {
        newTab,
        didLogin,
        fetchRefreshCookie,
        fetchUser,
        handleError,
        handleSkipResume,
        isRegistrationFlow,
        handleResumeCases,
      } = this.props

      if ((isRegistrationFlow && !didLogin && !newTab) || !isRegistrationFlow) {
        return handleSkipResume()
      }

      return fetchRefreshCookie().then(fetchUser).then(handleResumeCases).catch(handleError)
    },
  }),
)

const SpinnerContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -25px;
  margin-left: -25px;
`

const Loading = ({ showWelcomeModal, handleContinue, registrationComplete }) => {
  const handleModalAction = () => {
    trackEvent('Button Tapped', { eventData: buttonTapped })
    handleContinue()
  }

  if (showWelcomeModal && !registrationComplete) {
    trackEvent('Container Viewed', { eventData: modalViewed })
    return (
      <ConfirmationModal
        data-testid={TestIDs.SIGNUP.RESUME_MODAL}
        isOpen={showWelcomeModal}
        image={CheckImage}
        onRequestClose={handleModalAction}
        actions={[
          {
            label: 'Continue',
            type: ModalActionTypes.primary,
            handler: handleModalAction,
          },
        ]}
        message="Let's finish setting up your Acorns account so you can start investing for your future."
        title="Good to see you again"
      />
    )
  }

  return (
    <SpinnerContainer>
      <Spinner />
    </SpinnerContainer>
  )
}

export default ResumeFlow(Loading)
